const orderRouter = [
  {
    path: '/order/pay',
    name: 'OrderPay',
    component: () => import('@/views/order/pay')
  },
  {
    path: '/order/pay/offline',
    name: 'OrderPayOffline',
    component: () => import('@/views/order/pay_offline')
  },
  {
    path: '/order/pay/success',
    name: 'OrderPaySuccess',
    component: () => import('@/views/order/pay_success')
  }
]

export default orderRouter



// WEBPACK FOOTER //
// ./src/router/modules/order.js